import { CXChargeBlock } from '~/components/ClientExperience/OneFlow/models/cx-charge-block.model';
import { CXChargeContainerBlock } from '~/components/ClientExperience/OneFlow/models/cx-charge-container-block.model';
import { CXCompanyInfoBlock } from '~/components/ClientExperience/OneFlow/models/cx-company-info-block.model';
import { CXContainerBlock } from '~/components/ClientExperience/OneFlow/models/cx-container-block.model';
import { CXContractBlock } from '~/components/ClientExperience/OneFlow/models/cx-contract-block.model';
import { CXContractHTMLBlock } from '~/components/ClientExperience/OneFlow/models/cx-contract-html-block.model';
import { CXImageBlock } from '~/components/ClientExperience/OneFlow/models/cx-image-block.model';
import { CXInvoiceBlock } from '~/components/ClientExperience/OneFlow/models/cx-invoice-block.model';
import { CXInvoiceColumnHeaderBlock } from '~/components/ClientExperience/OneFlow/models/cx-invoice-column-header-block.model';
import { CXInvoiceHeaderBlock } from '~/components/ClientExperience/OneFlow/models/cx-invoice-header-block.model';
import { CXInvoiceServiceItemBlock } from '~/components/ClientExperience/OneFlow/models/cx-invoice-service-item-block.model';
import { CXInvoiceSummaryBlock } from '~/components/ClientExperience/OneFlow/models/cx-invoice-summary-block.model';
import { CXPaymentBlock } from '~/components/ClientExperience/OneFlow/models/cx-payment-block.model';
import { CXPaymentScheduleBlock } from '~/components/ClientExperience/OneFlow/models/cx-payment-schedule-block.model';
import { CXQuestionBlock } from '~/components/ClientExperience/OneFlow/models/cx-question-block.model';
import { CXRecurringScheduleBlock } from '~/components/ClientExperience/OneFlow/models/cx-recurring-schedule-block.model';
import { CXServiceItemsContainerBlock } from '~/components/ClientExperience/OneFlow/models/cx-service-items-container-block.model';
import { CXServiceSelectionBlock } from '~/components/ClientExperience/OneFlow/models/cx-service-selection-block.model';
import { CXServiceSelectionItemBlock } from '~/components/ClientExperience/OneFlow/models/cx-service-selection-item-block.model';
import { CXServicesBlock } from '~/components/ClientExperience/OneFlow/models/cx-services-block.model';
import { CXSignatureBlock } from '~/components/ClientExperience/OneFlow/models/cx-signature-block.model';
import { CXSignaturesBlock } from '~/components/ClientExperience/OneFlow/models/cx-signatures-block.model';
import { CXSocialBlock } from '~/components/ClientExperience/OneFlow/models/cx-social-block.model';
import { CXSpacerBlock } from '~/components/ClientExperience/OneFlow/models/cx-spacer-block.model';
import { CXTextBlock } from '~/components/ClientExperience/OneFlow/models/cx-text-block.model';
import { CXVideoBlock } from '~/components/ClientExperience/OneFlow/models/cx-video-block.model';
import { CXIframeBlock } from '~/components/ClientExperience/OneFlow/models/cx-iframe-block.model';
import type { CXRootStore } from '~/components/ClientExperience/stores/cx-root.store';
import { CXScheduleContainerBlock } from '~/components/ClientExperience/OneFlow/models/cx-schedule-container-block.model';
import { CXScheduleSessionBlock } from '~/components/ClientExperience/OneFlow/models/cx-schedule-session-block.model';
import type { FlowRevision } from '~/models/flow-revision.model';
import { TBlock } from '~/types/builder.types';
import { TCXBlock } from '~/types/client-experience.types';
import { TBlockType } from '~/types/model.types';
import { TBlockResponse } from '~/types/server.types';
import { CXLeadDetailsBlock } from '~/components/ClientExperience/OneFlow/models/cx-lead-details-block.model';

// TODO: Fix this! Type was previously `Record<TBlockType, typeof BaseBlock>` but there were type issues
// Either we fix this, or... in the near future we'll just delete this function
// after consolidating cx block models into block models
export const BLOCK_CLASS_BY_TYPE: Record<TBlockType, any> = {
    charge_block: CXChargeBlock,
    charge_container_block: CXChargeContainerBlock,
    company_info_block: CXCompanyInfoBlock,
    container_block: CXContainerBlock,
    contract_block: CXContractBlock,
    contract_html_block: CXContractHTMLBlock,
    iframe_block: CXIframeBlock,
    image_block: CXImageBlock,
    invoice_column_header_block: CXInvoiceColumnHeaderBlock,
    invoice_container_block: CXInvoiceBlock,
    invoice_header_block: CXInvoiceHeaderBlock,
    invoice_service_item_block: CXInvoiceServiceItemBlock,
    invoice_summary_block: CXInvoiceSummaryBlock,
    lead_details_block: CXLeadDetailsBlock,
    payment_block: CXPaymentBlock,
    payment_schedule_block: CXPaymentScheduleBlock,
    question_block: CXQuestionBlock,
    recurring_schedule_block: CXRecurringScheduleBlock,
    schedule_container_block: CXScheduleContainerBlock,
    schedule_session_block: CXScheduleSessionBlock,
    service_items_container_block: CXServiceItemsContainerBlock,
    service_selection_block: CXServiceSelectionBlock,
    service_selection_item_block: CXServiceSelectionItemBlock,
    services_block: CXServicesBlock,
    signature_block: CXSignatureBlock,
    signatures_block: CXSignaturesBlock,
    social_block: CXSocialBlock,
    spacer_block: CXSpacerBlock,
    text_block: CXTextBlock,
    video_block: CXVideoBlock
};

// TODO: this file should be deleted once we consolidate cx and builder blocks
export function createBlockInstance<T extends TCXBlock>(
    block: TBlockResponse | TBlock,
    flowRevision: FlowRevision<CXRootStore>,
    rootStore: CXRootStore
) {
    const BlockClass = BLOCK_CLASS_BY_TYPE[block.type];

    if (!BlockClass) {
        throw new Error(`No block class found for type: ${block.type}`);
    }

    return <T>new BlockClass(block, flowRevision, rootStore);
}
